@if (articleDetail && !errored && !loading) {
  <div class="article-container">
    <div class="content-pad">
      <h1>{{ articleDetail.title }}</h1>
    </div>
    <div class="titular-img phone">
      <img
        [src]="articleDetail.mainPhoto?.url ?? '/assets/images/blog_default_photo_lg.jpg'"
        onerror="this.src='/assets/images/blog_default_photo_sm.jpg';"
        [attr.alt]="articleDetail.mainPhoto?.alt ?? ''"
        data-cy="detail-main-photo"
        />
        @if (articleDetail.mainPhoto?.copyright) {
          <small
            class="copyright"
            data-cy="main-photo-copyright"
          >{{ articleDetail.mainPhoto?.copyright }}</small>
        }
      </div>
      <div class="content-pad">
        <div class="article-info">
          <svg-icon src="assets/icons/calendar.svg" [svgStyle]="{ 'width.px':27, 'height.px':28 }" svgClass="svg-icon-calendar"></svg-icon>
          <span>{{ articleDetail.publishOn | date:'d. M. y' }}</span>
          <svg-icon src="assets/icons/eye.svg" [svgStyle]="{ 'width.px':50, 'height.px':45 }" svgClass="svg-icon-eye"></svg-icon>
          <span>{{ articleDetail.readingTime ? articleDetail.readingTime : 0 }} min</span>
        </div>
      </div>
      <div class="titular-img desktop">
        <img
          [src]="articleDetail.mainPhoto?.url ?? '/assets/images/blog_default_photo_lg.jpg'"
          onerror="this.src='/assets/images/blog_default_photo_lg.jpg';"
          [attr.alt]="articleDetail.mainPhoto?.alt ?? ''"
          />
          @if (articleDetail.mainPhoto?.copyright) {
            <small class="copyright">{{ articleDetail.mainPhoto?.copyright }}</small>
          }
        </div>
        <div class="content-pad">
          <div class="article-perex">
            {{ articleDetail.perex }}
          </div>
          <div
            class="article-body"
            [innerHTML]="sanitizedHtmlFreeText"
            data-cy="blog-detail-body"
            (click)="clickArticleContent($event)"
            (keydown.space)="clickArticleContent($event)"
            (keydown.enter)="clickArticleContent($event)"
            tabindex="0"
          ></div>
          @if (this.sanitizedHtmlPremiumContent) {
            <div
              class="article-premium-content"
              (click)="clickArticleContent($event)"
              (keydown.space)="clickArticleContent($event)"
              (keydown.enter)="clickArticleContent($event)"
              tabindex="0"
              [innerHTML]="sanitizedHtmlPremiumContent"
              data-cy="blog-detail-premium-content"
            ></div>
          }
        </div>
        @if (showOtherPosts) {
          <div class="other-articles">
            <h2 class="title">Další články</h2>
            <libero-blog-other-articles-carousel [otherPosts]="otherPosts"></libero-blog-other-articles-carousel>
          </div>
        }
      </div>
    }

    <!-- ERROR WHEN RETRIEVING-->
    @if (!articleDetail && errored && !loading) {
      <div class="article-container">
        <div class="content-pad">
          <h1>{{ 'blog.detailErrorHeading' | translate }}</h1>
          <div class="article-perex">
            {{ 'blog.detailErrorBody' | translate }}
          </div>
        </div>
      </div>
    }

    <!-- LOADING -->
    @if (!articleDetail && !errored && loading) {
      <div class="article-container">
        <div class="content-pad">
          <libero-preload-spinner></libero-preload-spinner>
        </div>
      </div>
    }
